<template>
  <div class="page flex-col justify-between">
    <div class="group_1 flex-col">
      <div class="box_1 flex-col"></div>
      <div class="box_2 flex-col">
        <div class="section_2 flex-col"></div>
        <div class="image-text_1 flex-col justify-between">
          <div class="avatar-container" @click="handleAvatarClick">
            <img
              class="image_2"
              referrerpolicy="no-referrer"
              :src="userInfo.avatar || require('./assets/img/FigmaDDSSlicePNG7bad2c9d5db4195c4732a6ade905cac1.png')"
              @error="handleImageError"
            />
            <!-- 管理员标识 -->
            <div v-if="userInfo.is_admin" class="admin-badge">管理</div>
          </div>
          <span class="text-group_1">{{ userInfo.username || '用户' }}</span>
        </div>
        <div class="section_3 flex-row">
          <div class="text-group_2 flex-col justify-between">
            <span class="text_2">我的积分</span>
            <span class="text_3">{{ userInfo.balance || 0 }}</span>
          </div>
          <div class="text-wrapper_1 flex-col" @click="goToRecharge">
            <span class="text_4">去充值</span>
          </div>
        </div>
      </div>
    </div>

    <div class="group_5 flex-col">
      <div class="text-wrapper_2 flex-col" @click="logout">
        <span class="text_5">退出登录</span>
      </div>
      <div class="box_3 flex-col">
        <div class="group_6 flex-row" @click="showRechargeHistory">
          <img
            class="menu-icon"
            referrerpolicy="no-referrer"
            src="./assets/img/Frame(1).png"
          />
          <span class="text_6">充值记录</span>
          <img
            class="thumbnail_1"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNGdebf42576178572a64a8573bac25f2cb.png"
          />
        </div>
        <div class="group_7 flex-row" @click="generatePaper">
          <img
            class="menu-icon"
            referrerpolicy="no-referrer"
            src="./assets/img/Frame(3).png"
          />
          <span class="text_7">论文生成</span>
          <img
            class="thumbnail_2"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNGdebf42576178572a64a8573bac25f2cb.png"
          />
        </div>
        <div class="group_9 flex-row" @click="changePassword">
          <img
            class="menu-icon"
            referrerpolicy="no-referrer"
            src="./assets/img/889a1c162fc143b2a2aae9f552ba9deb_mergeImage.png"
          />
          <span class="text_8">修改密码</span>
          <img
            class="thumbnail_4"
            referrerpolicy="no-referrer"
            src="./assets/img/FigmaDDSSlicePNGdebf42576178572a64a8573bac25f2cb.png"
          />
        </div>

        <div class="group_11 flex-col"></div>
        <div class="group_12 flex-col"></div>
        <div class="group_13 flex-col"></div>
      </div>
    </div>
    <!-- 底部导航栏 -->
    <BottomNavigation :currentRoute="$route.path" />
  </div>
</template>
<script>
import axios from 'axios'
import { Toast } from 'vant'
import { API_ENDPOINTS } from '@/config/api'
import BottomNavigation from '@/components/BottomNavigation.vue'

export default {
  components: {
    BottomNavigation
  },
  data() {
    return {
      userInfo: {
        username: '',
        balance: 0,
        email: '',
        domain: '',
        avatar: ''
      }
    };
  },
  async mounted() {
    await this.getUserInfo();
  },
  methods: {
    showToast(message) {
      Toast(message);
    },
    
    // 获取用户信息
    async getUserInfo() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/lanhu_yonghudenglu');
          return;
        }
        
        const res = await axios.get(API_ENDPOINTS.USER.INFO, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (res.data.code === 0) {
          this.userInfo = res.data.data;
        } else {
          this.showToast(res.data.message || '获取用户信息失败');
        }
      } catch (error) {
        console.error('获取用户信息失败:', error);
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('token');
          this.$router.push('/lanhu_yonghudenglu');
        } else {
          this.showToast('获取用户信息失败，请重试');
        }
      }
    },
    
    // 修改密码
    async changePassword() {
      try {
        const { value: newPassword } = await this.$dialog.prompt({
          title: '修改密码',
          message: '请输入新密码',
          inputPlaceholder: '请输入新密码',
          inputType: 'password',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        });
        
        if (!newPassword) {
          return;
        }
        
        if (newPassword.length < 6) {
          this.showToast('密码长度不能少于6位');
          return;
        }
        
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/lanhu_yonghudenglu');
          return;
        }
        
        const res = await axios.post(API_ENDPOINTS.AUTH.CHANGE_PASSWORD, {
          newPassword: newPassword
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (res.data.code === 0) {
          this.showToast('密码修改成功');
        } else {
          this.showToast(res.data.message || '密码修改失败');
        }
      } catch (error) {
        if (error.name === 'cancel') {
          // 用户取消输入
          return;
        }
        console.error('密码修改失败:', error);
        this.showToast('密码修改失败，请重试');
      }
    },
    
    // 退出登录
    async logout() {
      try {
        await this.$dialog.confirm({
          title: '提示',
          message: '确定要退出登录吗？',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        });
      } catch (error) {
        // 用户取消
        return;
      }
      
      try {
        const token = localStorage.getItem('token');
        if (token) {
          await axios.post(API_ENDPOINTS.AUTH.LOGOUT, {}, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
        }
      } catch (error) {
        console.error('退出登录请求失败:', error);
      } finally {
        // 无论请求是否成功，都清除本地token并跳转到登录页
        localStorage.removeItem('token');
        this.$router.push('/lanhu_yonghudenglu');
      }
    },
    
    // 跳转到积分充值页面
    goToRecharge() {
      this.$router.push('/lanhu_jifenchongzhi');
    },
    
    // 论文生成
    generatePaper() {
      this.$router.push('/lanhu_lunwenshengcheng');
    },
    
    // 处理头像加载错误
    handleImageError(event) {
      // 如果头像加载失败，使用默认头像
      event.target.src = require('./assets/img/FigmaDDSSlicePNG7bad2c9d5db4195c4732a6ade905cac1.png');
    },
    
    // 显示充值记录
    showRechargeHistory() {
      this.$router.push('/lanhu_chongzhijilu');
    },

    // 处理头像点击
    handleAvatarClick() {
      if (this.userInfo.is_admin) {
        // 如果是管理员，直接跳转到系统管理页面
        this.$router.push('/system_management');
      } else {
        // 普通用户点击头像可以显示一些信息或者什么都不做
        this.showToast('点击头像查看个人信息');
      }
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
.text-wrapper_1,
.text-wrapper_2,
.group_6,
.group_7,
.group_9,
.group_10 {
  cursor: pointer;
  transition: all 0.2s ease;
}

.text-wrapper_1:hover,
.text-wrapper_2:hover,
.group_6:hover,
.group_7:hover,
.group_9:hover,
.group_10:hover {
  transform: scale(1.02);
  background-color: #f5f5f5;
}

.text-wrapper_1:active,
.text-wrapper_2:active,
.group_6:active,
.group_7:active,
.group_9:active,
.group_10:active {
  transform: scale(0.98);
}

.text-wrapper_2 {
  background-color: #fff;
  color: white;
  border-radius: 8px;
  padding: 10px;
}

.text-wrapper_2:hover {
  background-color: #ff3838 !important;
}

/* 菜单图标统一样式 */
.menu-icon {
  width: 20px;
  height: 20px;
  margin-right: 12px;
  flex-shrink: 0;
}

/* 修复group_6, group_7, group_9的布局 */
.group_6,
.group_7,
.group_9 {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  margin: 8px 0px;
  width: calc(100% - 30px);
}

.group_6 .text_6,
.group_7 .text_7,
.group_9 .text_8 {
  flex: 1;
  margin-left: 0;
  line-height: 20px;
  display: inline-block;
}

.thumbnail_1,
.thumbnail_2,
.thumbnail_4 {
  width: 16px;
  height: 16px;
  margin-left: auto;
}

/* 头像容器样式 */
.avatar-container {
  position: relative;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.avatar-container:hover {
  transform: scale(1.05);
}

/* 管理员标识 */
.admin-badge {
  position: absolute;
  bottom: -5px;
  right: -5px;
  background: #007bff;
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 10px;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}
</style>